import React from 'react';
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import IosShareIcon from '@mui/icons-material/IosShare';

const API_HOST = CONFIG.modules['accounts'].host
const API_HOST_CRM = CONFIG.modules['crm'].host







export const SankalpList = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Employees')
    const [data, setData] = useState([])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [count, setCount] = useState(0)
    const [filter, setFilter] = useState({
        from: dayjs('01-01-2023'),
        to: dayjs(),
    })


    const getList = () => {
        setData([])
        axios.get(API_HOST_CRM + `/cases?sankalp=yes&limit=${rowsPerPage}&page=${page}${
            filter.from?`&from=${dayjs(filter.from).format('YYYY-MM-DD')}`:''
            }${filter.to?`&to=${dayjs(filter.to).format('YYYY-MM-DD')}`:''}
            ${filter.status?`&status=${filter.status}`:''}
            `)
        .then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data.cases)
                setCount(resp.data.count)
            }

        }).catch((e) => {

            console.log(e)
        })
    }

    useEffect(()=>{
        getList()
    },[page,rowsPerPage, filter])


    useEffect(() => {
        getList()
    }, [])

    return (
        <>
   <ToolBar name={'Sankalp Data'} buttons={[
                // {
                //     name: 'Export',
                //     // type: 'chip',
                //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
                //     onClick: () => {
                //     }
                // }
            ]}

            filters={[
                {
                    field: {
                        name: 'status',
                        type: 'select',
                        label: 'Status',
                        option: { key: 'Status', value: '_id', label: 'name' },

                    },
                    data:{
                        Status:
                            ['Any','done', 'notDone', 
                            ].map(d => ({ _id: d, name: d }))
                    },
                    onChange: (name, value) => {
                        filter[name] = value
                        setFilter({...filter})
                    },
                    state: filter

                },
                {
                    field: {
                        name: 'from',
                        type: 'date',
                        label: 'From',
                    },
                    onChange: (name, value) => {
                        filter[name] = value
                        setFilter({...filter})
                    },
                    state: filter

                },
                {
                    field: {
                        name: 'to',
                        type: 'date',
                        label: 'To',
                    },
                    onChange: (name, value) => {
                        filter[name] = value
                        setFilter({...filter})
                    },
                    state: filter

                }
            ]}

                />
            <Box sx={{ mt: 2 }}>
                <Grid data={data} columns={[
                    { id: 'motherID', label: 'Mother ID', minWidth: 70 },
                    // { id: 'name', label: 'Name', minWidth: 70 },

                    { id: 'contact', label: 'Contact', minWidth: 70 },
                    { id: 'districtName', label: 'District', minWidth: 50 },
                    // { id: 'type', label: 'Type', minWidth: 50 },
                    { id: 'allocatedTo', label: 'AllocatedTo', minWidth: 70 },
                    { id: 'status', label: 'Status', minWidth: 50 },
                    { id: 'sankalpData', label: 'Trimester', minWidth: 50, format: (data, row)=> {
                        return data?data.trimester:''
                    } },
                    {
                        id: 'callDate', label: 'Call Date', minWidth: 70, format: (data, row) => {
                            return data ? dayjs(data).format('DD-MM-YYYY') : ''
                        }
                    },

                ]}

                    pagination={{
                        rowsPerPageOptions: [10, 25, 50],
                        page,
                        rowsPerPage,
                        onPageChange: (event, newPage) => {
                            setPage(newPage);
                        },
                        onRowsPerPageChange: (event) => {
                            setRowsPerPage(+event.target.value);
                            setPage(0);
                        },
                        count
                    }}
                >

                </Grid>
            </Box>

        </>
    )
}
